import React, { useState, useEffect } from 'react';
import FeatherIcon from "feather-icons-react";
import { Logo } from "../_components/Imagepath";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { useTranslation } from 'react-i18next';
import Lang from '../common/Lang';

const Documentation = () => {
    const [selectedDoc, setSelectedDoc] = useState('agency');
    const { t, i18n } = useTranslation();
    
    const documentationLinks = {
        "id": {
            agency: 'https://docs.google.com/document/d/1BSObsDCXzjCTlGIYi3QcyZg7pjzHdiDl59EKJflI118/edit?usp=sharing',
            vendor: 'https://docs.google.com/document/d/1_o9qdBGpAKB5dM8qcVUKY2K7BtIqlzkKT23CVN2UWAE/edit?usp=sharing'
        },
        "en": {
            agency: 'https://docs.google.com/document/d/12Tr3QuyJ4uU9nKvFFyURyH547d5_fM5DHV1vJe-ltfc/edit?usp=sharing',
            vendor: 'https://docs.google.com/document/d/1Xjh0RoWSmHEQr6sLS3nTiFLuTizvlj3ovVVcMwwcLwU/edit?usp=sharing'
        },
        "tgl": {
            agency: 'https://docs.google.com/document/d/1GEE9bJbtUDInJZPiNPg2B7vOc93zvZdDliXRGUKLbxc/edit?usp=sharing',
            vendor: 'https://docs.google.com/document/d/1lAnzs2gni40_AxQTuUM0YMM0mXgUUU4VeEtnwcWKHmA/edit?usp=sharing'
        }
    };

    // Read URL parameters on component mount
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const docType = urlParams.get('type');
        
        // Check if the parameter is valid and set the document type
        if (docType && ['agency', 'vendor'].includes(docType.toLowerCase())) {
            setSelectedDoc(docType.toLowerCase());
        }
    }, []);

    // Update URL when document type changes
    const handleDocumentChange = (docType) => {
        setSelectedDoc(docType);
        
        // Update URL parameter without page reload
        const url = new URL(window.location);
        url.searchParams.set('type', docType);
        window.history.replaceState({}, '', url);
    };

    // Convert Google Docs link to embed format
    const getEmbedUrl = (url) => {
        return url.replace('/edit?usp=sharing', '/preview');
    };

    // Get current language documentation links
    const getCurrentDocumentationLink = (docType) => {
        const currentLang = i18n.language || 'en';
        return documentationLinks[currentLang]?.[docType] || documentationLinks['en'][docType];
    };

    return (
        <div className="documentation-page" style={{ minHeight: '100vh', backgroundColor: '#f8fafc' }}>
            <div className="container-fluid">
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-10 col-xl-8">

                        
                        <div className="row">
                            <div className="col-12">
                            <div className="card bg-white">
                                <div className="card-header">
                                     <div className="d-flex align-items-center justify-content-between">
                                           <div className='d-flex align-items-center'>
                                             <img src={Logo} alt="Kflow Logo" height="32" className="me-2" />
                                           </div>
                                        <Lang />
                                    </div>
                                    <div className="d-flex justify-content-end mb-2">
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex gap-2">
                                             <Link to="/dashboard" className="btn btn-sm btn-secondary">
                                                <FeatherIcon icon="arrow-left" size={7} className="me-1" />
                                                {t("Back to Dashboard")}
                                            </Link>
                                            <button 
                                                className={`btn btn-sm ${selectedDoc === 'agency' ? 'btn-primary' : 'btn-outline-primary'}`}
                                                onClick={() => handleDocumentChange('agency')}
                                            >
                                                <FeatherIcon icon="users" size={7} className="me-1" />
                                                Agency Guide
                                            </button>
                                            <button 
                                                className={`btn btn-sm ${selectedDoc === 'vendor' ? 'btn-primary' : 'btn-outline-primary'}`}
                                                onClick={() => handleDocumentChange('vendor')}
                                            >
                                                <FeatherIcon icon="briefcase" size={14} className="me-1" />
                                                Vendor Guide
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="card-body p-0">
                                    <div style={{ height: '80vh', position: 'relative' }}>
                                        <iframe
                                            src={getEmbedUrl(getCurrentDocumentationLink(selectedDoc))}
                                            title={`${selectedDoc} Documentation`}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                border: 'none',
                                                borderRadius: '0 0 0.375rem 0.375rem'
                                            }}
                                            allowFullScreen
                                        >
                                            <div className="d-flex flex-column align-items-center justify-content-center h-100 p-4">
                                                <FeatherIcon icon="alert-circle" size={48} className="text-muted mb-3" />
                                                <p className="text-muted mb-3">Unable to load document. Please use the direct link:</p>
                                                <a 
                                                    href={getCurrentDocumentationLink(selectedDoc)} 
                                                    target="_blank" 
                                                    rel="noopener noreferrer"
                                                    className="btn btn-primary"
                                                >
                                                    <FeatherIcon icon="external-link" size={14} className="me-1" />
                                                    Open {selectedDoc} Documentation
                                                </a>
                                            </div>
                                        </iframe>
                                    </div>
                                </div>
                                
                                <div className="card-footer d-flex justify-content-end">
                                    <a 
                                        href={getCurrentDocumentationLink(selectedDoc)} 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        className="btn btn-outline-primary btn-sm"
                                    >
                                        <FeatherIcon icon="external-link" size={14} className="me-1" />
                                        Open in New Tab
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    );
};

export default Documentation;